import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  crewRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "10px",
    marginTop: "10px",
  },
  crewNameWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flexGrow: 1,
    maxWidth: "85%",
  },
  statusDotWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    maxWidth: "15%",
  },
}))

export default styles
